import CoinBase from "../images/coinbase.png";
import KSMART from "../images/KSMART.png";
import Talent from "../images/Talent.png";
import HomeLand from "../images/homeland.png";
import Recipe from "../images/Recipe.png";
import Ksuit from "../images/Ksuit.png";

export const myProjects = [
  {
    projectName: "KSMART",
    projectPhoto: KSMART,
    link: `https://ksmart.lsgkerala.gov.in/ui/web-portal/`,
    github: `#`,
    description:
      "React-based e-governance platform unifying civil registration, licensing, property tax, and grievance services for citizens",
  },
  {
    projectName: "Talent Scout",
    projectPhoto: Talent,
    link: `#`,
    github: `#`,
    description:
      "HR productivity platform for talent scouting with React, featuring node-edge data visualization and seamless API integration",
  },
  {
    projectName: "Ksuite",
    projectPhoto: Ksuit,
    link: `https://www.office.ikm.gov.in/ui/home/employee/login`,
    github: `#`,
    description:
      "Document management web portal for IKM enabling efficient file tracking and workflow management within office operations",
  },
  {
    projectName: "HomeLand",
    projectPhoto: HomeLand,
    link: `https://homeland-theta.vercel.app`,
    github: `https://github.com/pv-kiran/homeland`,
    description:
      "Discover UAE rental homes through this straightforward React app, simplifying your house hunting experience effortlessly.",
  },
  {
    projectName: "Recipe Finder",
    projectPhoto: Recipe,
    link: `https://recepie-app-rtkq.vercel.app/`,
    github: `https://github.com/pv-kiran/recepie-app-rtkq`,
    description:
      "Modern recipe discovery app powered by React and RTK Query, featuring efficient data fetching and detailed dish insights",
  },
  {
    projectName: "CoinBase",
    projectPhoto: CoinBase,
    link: `https://cryptoapp-puce.vercel.app`,
    github: `https://github.com/pv-kiran/cryptoapp`,
    description:
      "React app providing vital Bitcoin data for cryptocurrency enthusiasts and curious minds. Your gateway to crypto",
  },
];
